import React, { useEffect, useState, useCallback } from "react";
import { Box, TextField, Button, Chip, Paper, CircularProgress } from "@mui/material";
import { ConfirmDialog } from "primereact/confirmdialog";
import { getServiceProviderOrders, getProviderVenueOrders } from "../../Apiservices/Auth/servers/profileServer";
import config from '../../config';
import "./ServiceProviderDashboard.css";
import ServicesList from "./ServicesList";
import CateringService from "./redesigncatering/Cateringservices";
import TentHouseService from "./TentHouseService";
import PriestManageServices from "./PriestManageServices";
import HelperProvider from "./helperprovider/HelperPriceManager";
import OrderItemCard from "./OrderItemCard";
import OrderAgreementProofs from '../documents/OrderAgreementProofs';

function ManageOrdersTabContent({ onActiveTypeChange }) {
    const [providerOrders, setProviderOrders] = useState({ orders: [] });
    const [venueOrders, setVenueOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchProviderOrders = useCallback(async () => {
        setLoading(true);
        try {
            const [result, venues] = await Promise.all([getServiceProviderOrders(), getProviderVenueOrders()]);
            setProviderOrders({
                orders: result || [],
            });
            setVenueOrders(venues || []);
            console.log(`Length ${result ? result.length : 0}`)
        } catch (error) {
            console.error("Failed to services:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchProviderOrders();
    }, [fetchProviderOrders]);

    return (
        <>
            <ConfirmDialog />
            <OrderAgreementProofs />
            {loading ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        width: "100%",
                        backgroundColor: "#transparent",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : providerOrders.orders.length > 0 ? (
                providerOrders.orders.map((order) => (
                    <OrderItemCard key={order.order_item_id} orderData={order} />
                ))
            ) : (
                // <Paper sx={{ p: 2, backgroundColor: "#f8f8f8" }}>
                <div>
                    <h4>No Services Available</h4>
                </div>
                // </Paper>
            )}
            {venueOrders.length > 0 && <section className="profile-documents-section">
                <h3>Venue contract documents</h3>
                {venueOrders.map((order) => {
                    const document = order.contractDocument;
                    const signed = document?.signedContractFile;
                    const original = document?.originalContractFile;
                    return <div className="profile-document-row" key={`venue-contract-${order.id}`}>
                        <OrderAgreementProofs serviceType="venue" cartItemId={order.id} />
                        <div><strong>{order.venue?.name || 'Venue booking'}{order.space?.name ? ` — ${order.space.name}` : ''}</strong><div>{signed ? 'Signed contract submitted' : original ? 'No signed contract submitted' : 'No contract uploaded'}</div></div>
                        {original && <a href={`${config.API_BASE_URL}/gallery/download/${original.id}?isDownload=true`} target="_blank" rel="noreferrer">Original contract</a>}
                        {signed && <a href={`${config.API_BASE_URL}/gallery/download/${signed.id}?isDownload=true`} target="_blank" rel="noreferrer">Signed contract</a>}
                    </div>;
                })}
            </section>}
        </>
    );
}
export default ManageOrdersTabContent;
